import { Link } from 'react-router-dom';
import { statsData } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-secondary-100">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-20">
          <div className="lg:w-[35%] flex-shrink-0">
            <span className="inline-block px-3 py-1.5 rounded-full bg-secondary-200 text-secondary-800 text-xs font-semibold tracking-wide mb-6">
              Mulebuy Spreadsheet Guide
            </span>
            <h2 className="text-foreground-950 text-2xl md:text-[2.5rem] font-heading font-bold leading-tight mb-6">
              What is <span className="italic font-light">Mulebuy Spreadsheet?</span>
            </h2>
            <Link
              to="/mulebuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Read the full guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[65%]">
            <div className="text-foreground-700 text-base md:text-lg leading-relaxed space-y-5">
              <p>
                The <strong>mulebuy spreadsheet</strong> is a structured comparison system designed to help users evaluate different buying agents, sourcing platforms, and product options in a clear and organized format. Instead of manually checking multiple websites, smart buyers rely on this spreadsheet-style methodology to centralize pricing information, product availability, shipping estimates, and platform reliability scores.
              </p>
              <p>
                The mulebuy spreadsheet approach simplifies complex buying decisions by organizing everything into one structured dashboard. This method has become increasingly popular among international buyers who value speed, clarity, and data-driven decision-making when comparing products across different categories and platforms.
              </p>
              <p>
                Whether you are browsing shoes, hoodies, jackets, or accessories, the <strong>mulebuy spreadsheet</strong> comparison system gives you a centralized view that saves hours of manual research. <Link to="/mulebuy-spreadsheet-complete-guide" className="text-primary-600 hover:text-primary-700 underline font-medium cursor-pointer">Learn more about how it works in our complete guide.</Link>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-foreground-950 text-3xl md:text-4xl font-heading font-bold mb-2">{stat.value}</div>
              <div className="text-foreground-500 text-sm md:text-base">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}